import {
    FONT_INTER,
    FONT_LORA,
    FONT_MERRIWEATHER,
    FONT_MONTSERRAT,
    FONT_NOTO_SERIF,
    FONT_OPEN_SANS,
    FONT_PT_SERIF,
    FONT_RALEWAY,
    FONT_ROBOTO,
    FONT_ROBOTO_SLAB,
    FONT_RUBIK,
    FONT_UBUNTU,
} from './constants.js';
export default (name) => {
    const fontsMap = {
        [FONT_INTER]: 'https://widget-market.s3lds.ru/fonts/css/Inter_wght.css',
        [FONT_MONTSERRAT]: 'https://widget-market.s3lds.ru/fonts/css/Montserrat_wght.css',
        [FONT_ROBOTO]: 'https://widget-market.s3lds.ru/fonts/css/Roboto_wght.css',
        [FONT_RALEWAY]: 'https://widget-market.s3lds.ru/fonts/css/Raleway_wght.css',
        [FONT_UBUNTU]: 'https://widget-market.s3lds.ru/fonts/css/Ubuntu_wght.css',
        [FONT_OPEN_SANS]: 'https://widget-market.s3lds.ru/fonts/css/Open_Sans_wght.css',
        [FONT_RUBIK]: 'https://widget-market.s3lds.ru/fonts/css/Rubik_wght.css',
        [FONT_MERRIWEATHER]: 'https://widget-market.s3lds.ru/fonts/css/Merriweather_wght.css',
        [FONT_LORA]: 'https://widget-market.s3lds.ru/fonts/css/Lora_wght.css',
        [FONT_PT_SERIF]: 'https://widget-market.s3lds.ru/fonts/css/PT_Serif_wght.css',
        [FONT_NOTO_SERIF]: 'https://widget-market.s3lds.ru/fonts/css/Noto_Serif_wght.css',
        [FONT_ROBOTO_SLAB]: 'https://widget-market.s3lds.ru/fonts/css/Roboto_Slab_wght.css',
    };
    return fontsMap[name] || fontsMap[FONT_MONTSERRAT];
}